import { Directive, Host, Input, OnChanges, Optional, Renderer2, SimpleChanges } from '@angular/core';
import { DziViewerComponent } from '../../dzi-viewer.component';

enum ImageFilterType {
  CONTRAST = 'contrast',
  SATURATION = 'saturation',
  BRIGHTNESS = 'brightness',
  NEGATIVE = 'negative',
}

@Directive({
  selector: '[tsDziImageFilters]',
  standalone: false,
})
export class DziImageFiltersDirective implements OnChanges {
  @Input() imageFilters: {
    filter: ImageFilterType;
    value: number;
  }[];

  constructor(@Host() @Optional() private dziViewer: DziViewerComponent, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { imageFilters } = changes;

    if (!imageFilters) return;

    if (!imageFilters.currentValue) return;

    this.updateFilters();
  }

  private updateFilters() {
    if (!this.dziViewer) return;

    const canvas = this.dziViewer['viewer'].canvas.querySelector('canvas');

    if (!canvas) return;

    const filterString = this.imageFilters
      .map((filter) => {
        if (filter.filter === ImageFilterType.NEGATIVE) return `invert(${filter.value})`;

        const value = 1 + filter.value / 100;

        if (filter.filter === ImageFilterType.SATURATION) return `saturate(${value})`;

        return `${filter.filter}(${value})`;
      })
      .join(' ');

    this.renderer.setStyle(canvas, 'filter', filterString);
  }
}
